import React from 'react'

import { Dropdown } from '@sketch/components'
import {
  ProjectListItemFragment,
  WorkspaceMinimalFragment,
} from '@sketch/gql-types'

import {
  CopyProjectAction,
  LeaveProjectAction,
  RestoreProjectAction,
  DeleteProjectPermanentlyAction,
} from '../ProjectDropdownActions'

export interface ProjectTrashedDropdownProps {
  workspace: Pick<WorkspaceMinimalFragment, 'identifier'>
  project: Pick<
    ProjectListItemFragment,
    | '__typename'
    | 'identifier'
    | 'name'
    | 'userCanLeave'
    | 'deletedAt'
    | 'parentProjectIdentifier'
  >
}

export const ProjectTrashedDropdown: React.FC<
  ProjectTrashedDropdownProps
> = props => {
  const { workspace, project } = props
  const workspaceId = workspace.identifier

  return (
    <>
      <CopyProjectAction project={project} workspaceId={workspaceId} />
      <Dropdown.Divider />
      <RestoreProjectAction project={project} workspaceId={workspaceId} />
      <Dropdown.Divider />
      {project.userCanLeave && (
        <LeaveProjectAction
          workspaceIdentifier={workspaceId}
          projectIdentifier={project.identifier}
          projectName={project.name}
        />
      )}
      <DeleteProjectPermanentlyAction
        project={project}
        workspaceId={workspaceId}
      />
    </>
  )
}
